<template>
  <div class="pin--image">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 174 200"
    >
      <title v-if="title">{{ title }}</title>
      <circle
        cx="50%"
        cy="50%"
        r="50%"
        stroke="none"
      />
      <text
        x="50%"
        y="55%"
        font-size="6em"
        alignment-baseline="middle"
        dominant-baseline="middle"
        text-anchor="middle"
      >
        {{ formattedText }}
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    prefix: { type: String, default: '' },
    text: { type: String, default: '' },
    title: { type: String, default: '' },
  },
  computed: {
    formattedText() {
      if (this.text.length === 0) {
        return '';
      }

      return `${this.prefix}${this.text[0].toUpperCase()}`;
    },
  },
};
</script>
